import React, {ElementType, FC, Fragment, useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState} from 'react';
import MatchListItem from 'components/MatchListItem';
import {MatchGroup} from '../../utils/types';

import './styles.scss';

interface MatchListProps {
  matchGroups: Record<string, MatchGroup>;
  showAd?: boolean;
  index?: number;
  isMobile?: boolean;
  ListItemRender?: ElementType;
  isOpen?:boolean;
  handleClick?:any;
}

const MatchList: FC<MatchListProps> = ({
  matchGroups,
  showAd = false,
  index,
  isMobile = false,
  ListItemRender = MatchListItem,
  isOpen,
  handleClick
}: MatchListProps) => {
  const slot = useRef<any | null>(null);
  const clickHandlerRef = useRef<(() => void) | null>(null);

  // const [isOpen, setIsOpen] = useState(false);

  const divId = useMemo(
    () => `matchcenter-matchlist-third-party${typeof index === 'number' ? `-${index}` : ''}`,
    [index]
  );

//   const handleClick = useCallback((divOpen) => {
//     console.log("isOpen in click", divOpen)
//     if (document.body.classList.contains('has-open-matchcenter')){
//     setIsOpen(true);
//     console.log("slots", slot.current, divId, divOpen)
//     window.googletag = window.googletag || {cmd: []};
// // console.log('slots2', window.s24.matchcenterHpWidgetMobileSlots)
    
//     window.googletag.cmd.push(() => {

//       window.googletag.display(divId);

//       // window.googletag.pubads().refresh(Object.values(window.s24.matchcenterHpWidgetMobileSlots))
//     })
//   }
//   }, [ divId])
  
  useLayoutEffect(() => {
    if (showAd && !slot.current) {
      window.googletag = window.googletag || {cmd: []};
      /* eslint-disable no-nested-ternary */
      window.googletag.cmd.push(() => {
        // console.log("defining", isMobile)
        const mapping = isMobile
          ? window.googletag
              .sizeMapping()
              .addSize([1366, 0], [])
              .addSize([0, 0], [[300, 50], [300, 100], [300,250]])
              .build()
          : (index===2 && !isMobile)
          ? window.googletag
          .sizeMapping()
          .addSize([1200, 0], [])
          .addSize([0, 0], [[300, 50], [300, 100], [300,250]])
          .build()
          : window.googletag
              .sizeMapping()
              .addSize([768, 0], [[300, 50], [300, 100],[300,250]])
              .addSize([0, 0], [])
              .build();
        slot.current = window.googletag
          .defineSlot(
            `/4834629/sport24.gr/HP_300x100_matchcenter`,
            [
              [300, 50],
              [300, 100],
              [300, 250],
            ],
            divId
          )
          .defineSizeMapping(mapping)
          .addService(window.googletag.pubads())
          .setTargeting('article', '')
          .setTargeting('keywords', [])
          .setTargeting('category', 'homepage')
          .setTargeting('type', 'homepage')
          .setTargeting('isAmp', 'false')
          .setTargeting('isMobile', 'false');
        
        
        if (!isMobile) {
          // display ad immediately only on desktop
          window.googletag.display(divId);
        } else {
          // if mobile, add click listener to scores button
          window.s24 = window.s24 || {};
          window.s24.matchcenterHpWidgetMobileSlots = {...(window.s24.matchcenterHpWidgetMobileSlots || {}), [divId]: slot.current};
          const btn = document.querySelector('.global_header__scores-button');
          if (btn && !isOpen){
            // console.log("is open", isOpen)
            btn.addEventListener('click', handleClick);
            clickHandlerRef.current = handleClick;
          }
        }
      });
    }

    return () => {
      window.googletag = window.googletag || {cmd: []};
      window.googletag.cmd.push(() => {
        if (slot.current) {
          window.googletag.destroySlots([slot.current]);
          slot.current = null;
        }
      });
      const btn = document.querySelector('.global_header__scores-button');
      if (btn && clickHandlerRef.current){
        btn.removeEventListener('click', clickHandlerRef.current);
        clickHandlerRef.current = null;
      }
      window.s24 = window.s24 || {};
      if (window.s24.matchcenterHpWidgetMobileSlots) delete window.s24.matchcenterHpWidgetMobileSlots[divId];
    };
  }, [divId, isMobile, showAd, isOpen, handleClick, index]);
  
// console.log("isMobile:", isMobile, "divId:", divId, "showAd:", showAd, "isOpen:", isOpen)
  return (
    <>
      {Object.entries(matchGroups).map(([competitionId, {title: groupTitle, groupings}], i) => (
        <Fragment key={competitionId}>
          <section className="MatchList__group">
            {groupTitle && <h3 className="MatchList__title">{groupTitle}</h3>}
            {Object.entries(groupings).map(([groupingId, {title: subTitle, matches}]) => (
              <div key={groupingId}>
                {subTitle && <h4 className="MatchList__subtitle">{subTitle}</h4>}
                {matches.map(match => (
                  <ListItemRender className="MatchList__match" match={match} key={match.matchId} />
                ))}
              </div>
            ))}
          </section>
          {(showAd && i === 0 && index===0 && isOpen) && <div id={divId} className="MatchList__ad" />}
          {(showAd && i === 0 && index===1 && !isOpen) && <div id={divId} className="MatchList__ad" />}
          {(showAd && i === 0 && index===2) && <div id={divId} className="MatchList__ad" />}


        </Fragment>
      ))}
    </>
  );
};

export default React.memo(MatchList);
